import Modal from "react-bootstrap/esm/Modal"
import FormComponent from "./FormComponent";
import { useEffect, useMemo, useRef, useState } from "react";
import { findBrackets } from "../../utils/common";
import { Button, Col, Row } from "react-bootstrap";
import Editor, { CkEditorHandler } from "./CKEditor";
import { RiArrowRightSLine, RiCheckFill, RiCloseFill, RiQuestionLine } from "react-icons/ri";

interface FormFillerProps{
    show: boolean;
    fieldTitles: any;
    names: any;
    values: any;
    onHide: () => void;
    onChangeHandler: (name: string, data: string) => void;
    replaceOtherTage?: (dictionary: {id:string, value:string}[]) => void;
}

const FormFiller: React.FC<FormFillerProps> = (props) =>{
    const { show, fieldTitles, names, values, onHide, onChangeHandler, replaceOtherTage} = props;

    const textNum = useRef(0);
    const [currText, setCurrText] = useState("");
    const [showText, setShowText] = useState("");
    const matches = useMemo(() => findBrackets(currText)[0], [currText]);
    const initialLoad = useRef(true);
    const mountLoad = useRef(false);

    const [fieldName, setFieldName] = useState("");
    const [fieldValue, setFieldValue] = useState("");
    const [isBrackets, setIsBrackets] = useState(true);
    const [userInputDictionary, setUserInputDictionary] = useState<{id:string, value:string}[]>([{id:"", value:""}]);
    const [addtionalNote, setAddtionalNote] = useState(false);
    const [subPopupShow, setSubPopupShow] = useState(false);
    const [position, setPosition] = useState({top:0, left: 0});
    const [doNotShowAgain, setDoNotShowAgain] = useState(false);
    const [isConfirm, setConfirm] = useState(false);

    useEffect(() => {
      if (show && values){
        for (let i=0; i< values.length; i++){
          if (findBrackets(values[i]).length>0){
            setCurrText(values[i]);
            textNum.current = i;
            setIsBrackets(true);
            break;
          } else{
            setIsBrackets(false);
          }
        }

      }
    },[show])

    useEffect(() => {
      if (matches) {
        const { fieldName, fieldVal, start, end} = matches;
        setShowText(currText?.replaceAll("&gt;---&lt;", "").replaceAll(">---<", "").replaceAll("--</p><p>", "").replaceAll("</p><p>--", "").replace(fieldVal, `<span class="custom-highlight">${fieldVal}</span>`))
      } else
        setShowText(currText?.replaceAll("&gt;---&lt;", "").replaceAll(">---<", "").replaceAll("--</p><p>", "").replaceAll("</p><p>--", ""))
    }, [currText])

    useEffect(()=>{
      if (showText) {
        const tags = document.getElementsByClassName('custom-highlight');
        let tag;
        if (tags && tags.length > 0) {
          tag = tags[0];
          tag.scrollIntoView({ behavior: 'auto', block: 'center' });
          makePosition();
          setTimeout(()=>{
            setSubPopupShow(true);
          },200)  
      }
      }
    },[showText, subPopupShow])

    const makePosition = () => {
      const tags = document.getElementsByClassName('custom-highlight');
      const popupElements = document.getElementsByClassName('popup');
      let tag;
      let popup;
      if (tags && tags.length > 0)
        tag = tags[0];     
      if (popupElements && popupElements.length > 0)
        popup = popupElements[0];
      if (tag && popup) {
        const tagPosition = tag.getBoundingClientRect();
        const popupPosition = popup.getBoundingClientRect();
        const top = tagPosition.top + tagPosition.height + 10;
        const left =tagPosition.left + (tagPosition.width/2) - (popupPosition.width/2);
        setPosition({top: top, left: left})
    }
  }


    useEffect(() => {
      if ((textNum.current < values.length) && !matches && initialLoad.current && mountLoad.current){
        textNum.current += 1;
        setCurrText(values[textNum.current]);
      }
      else{
        initialLoad.current = false;
      }
      if (currText){
        onChangeHandler(names[textNum.current],currText);
      }
      mountLoad.current = true;
    },[currText, initialLoad.current])
    
    useEffect(() => {
      if (matches) {
        const { fieldName, fieldVal, start, end} = matches;
        setFieldName(fieldName);
      }else{
        setFieldName("");
      }
      setFieldValue("");
    }, [matches]);

    const onNextBtn = (value: string) => {
      if (matches) {
        const { fieldVal,fieldName } = matches;
        setCurrText(currText.replaceAll(fieldVal, value?.replace(/^<p>/, '').replace(/<\/p>$/, '').replace(/<p>&nbsp;<\/p>/g, '\n')));
        userInputDictionary.push({id:fieldName, value:value});
        for (let i = textNum.current; i < values.length; i++) {
          onChangeHandler(names[i], values[i]?.replaceAll(fieldVal, value?.replace(/^<p>/, '').replace(/<\/p>$/, '').replace(/<p>&nbsp;<\/p>/g, '\n')));
        }
      }
    };

    const onNextFiledBtn = () => {
      setSubPopupShow(false)
      let value: any = [];
      let isFinish = true;
      if ((textNum.current < values.length) && !matches){
              for (let i = textNum.current + 1; i < values.length; i++) {
                value = findBrackets(values[i]);
                if (value && value.length > 0) {
                  textNum.current = i;
                  isFinish = false;
                  setCurrText(values[i]);
                  break;
                }

              }
          }
          if (isFinish) {
            textNum.current = values.length;
            setCurrText(values[textNum.current]);
          }
    }

    const cancelPopup = () =>{
      if (!matches && replaceOtherTage)
        replaceOtherTage(userInputDictionary)
      setFieldName("");
      setFieldValue("");
      setUserInputDictionary([{id:"", value:""}]);
      setCurrText("");
      setShowText("");
      setIsBrackets(true);
      onHide();
      textNum.current =0;
      initialLoad.current = true;
      mountLoad.current = false;
    }

    useEffect(()=>{
      if (textNum.current < values.length && names[textNum.current] && names[textNum.current].startsWith("order-")) 
        setAddtionalNote(true);
      else
        setAddtionalNote(false);
    },[textNum.current, show])

    let data = [
      {
        type: "htmlTag",
        props: {
          value:  <label style={{fontSize: '15px', marginLeft: '4px', position: 'relative', top: '-8px'}}><b>TEMPLATE FIELD : </b><i>{Array.isArray(fieldTitles) && fieldTitles[textNum.current]}</i></label>
        },
        colSize: 12,
        colHide: (!(textNum.current !== values.length)  || !isBrackets)
      },
       {
         type: "htmlTag",
         props: {
          value: <label style={{fontSize:"13px", color: "blue", marginLeft: '4px'}}>{"Portion of the template that is getting filled out below (Read only)"}</label>
         },
         colSize: 12,
         colHide: (!(textNum.current !== values.length)  || !isBrackets)
       },
      {
        type: "htmlTag",
        props: {
          value:   <div className="rte-container">
          <div className="rte-toolbar">
            <select className="rte-dropdown" disabled>
              <option>Paragraph</option>
            </select>
          </div>
          <div className="rte-textarea"  dangerouslySetInnerHTML={{__html: showText}}></div>
        </div>
        },
        colSize: 12,
        colHide: (!(textNum.current !== values.length)  || !isBrackets)
      },
          {
            type: "htmlTag",
            props: {
              value: <h6>All the tags have been replaced.</h6>
            },
            colSize: 12,
            colHide: (textNum.current !== values.length) && isBrackets
          },
        {
          type: "customButtons",
          props:{},
          colSize: 12,
        }
    ]
    return(
      <>
        <Modal
          show={show}
          dialogClassName="modal-55w"
          onHide={cancelPopup}
          centered
          backdrop="static"
          scrollable={true}
          enforceFocus={false}
        >
          <Modal.Header >
            <span><b style={{fontSize: "19px"}}>📝 Form Filler Wizard </b><span style={{fontSize: "14px", color: "GrayText"}}>{addtionalNote?"Additional info needed: Please fill in the missing tag values in the warrant language to proceed": ""}</span></span>
          </Modal.Header>

          <Modal.Body>
            <FormComponent
              isSpace={"mt-0"}
              totalColumns={12}
              colSize={12}
              componentData={data}
              formCardStyle={"none"}
              components={[
                {
                  type: "customButtons",
                  node: (props: any) => (
                    <Row className="mt-4">
                      <Col className="text-end mt-1" xs={12}>
                        {((textNum.current !== values.length) && isBrackets) ?
                          <Button className="btn-primary ms-2"
                            onClick={onNextFiledBtn}
                            disabled={!(!matches && !fieldValue)}
                          >Next Field</Button> : ""}
                        {((textNum.current !== values.length) && isBrackets) ?
                          <Button className="btn-primary ms-2"
                            variant="danger"
                            onClick={cancelPopup}>Cancel</Button> : ""}
                        {(!(textNum.current !== values.length) || !isBrackets) ?
                          <Button className="btn-primary ms-2"
                            variant="danger"
                            onClick={cancelPopup}>Close</Button> : ""}
                      </Col>
                    </Row>
                  ),
                },
              ]}

            />
          </Modal.Body>
        </Modal>
        {subPopupShow && show && <TagPopup
          tagName={fieldName}
          nextClick={onNextBtn}
          nextFieldClick={onNextFiledBtn}
          close={() => setSubPopupShow(false)}
          position={position}
          makePosition={makePosition}
          setDoNotShowAgain={setDoNotShowAgain}
          doNotShowAgain={doNotShowAgain}
          isConfirm = {isConfirm} 
          setConfirm = {setConfirm}
        />}
      </>
    );
};

type TagPopupProps = {
  tagName: string,
  nextClick: (value: string) => void,
  nextFieldClick: () => void,
  close: () => void,
  position: { top: number, left: number },
  makePosition : () => void,
  setDoNotShowAgain : (flag: boolean) => void,
  doNotShowAgain : boolean,
  setConfirm : (flag: boolean) => void,
  isConfirm : boolean,
}

const TagPopup: React.FC<TagPopupProps> = ({
  tagName,
  nextClick,
  nextFieldClick,
  close,
  position,
  makePosition,
  setDoNotShowAgain,
  doNotShowAgain,
  setConfirm,
  isConfirm,
}) => {
  const [text, setText] = useState("");
  const ref = useRef<any>(null);
  const [confirmationModalShow, setConfirmationModalShow] = useState(false);
  const [emptyWarning, setEmptyWarning] = useState(false);
  
  useEffect(() => {
    if (!tagName || tagName === "") {
      if (doNotShowAgain && isConfirm)
          nextFieldClick()
      if (doNotShowAgain && !isConfirm)
        close();
      else  
        setConfirmationModalShow(true);
    }

  }, [tagName]);

  const nextTag = () => {
    if ((text === null || text === "") && !emptyWarning)
      setEmptyWarning(true);
    else {
      setEmptyWarning(false);
      setText("");
      nextClick(text);
    }
  };

  const onInputUpdate = (editor: any) => {
    setText(editor.getData());
    editor?.focus();
  };

  return (
    <>
      {!confirmationModalShow &&
        <div
          className="popup arrow-top smooth-popup"
          style={{
            top: position.top,
            left: position.left,
          }}
        >
          <div className={'popup-wrapper'}>
            
            <div className="popup-header">
              <div style={{ overflowX: "hidden", maxWidth: '500px' }}>
                <span><b>TAG NAME : </b>{tagName}</span>
              </div>
            </div>
            {emptyWarning &&
                <div style={{ marginTop: "-10px", paddingBottom: "5px" }}>
                  <span className="text-warning" style={{fontSize: "14px"}}><b>Warning : </b>Tag will be set as empty. If that’s okay, click Next again to proceed.</span>
                </div>
              }
            <Editor
              id={"sub-popup"}
              data={text}
              onChange={(event: any, editor: any) => onInputUpdate(editor)}
              className="no-min-height-editor"
              initialHeightvalue={125}
              ref={ref}
              isWarning={emptyWarning}
              widthRange={{min: 450, max: 900, intialWidth: 500}}
              enabledWidthChange={true}
              widthChangeAction={makePosition}
              onReady={(editor: any) => {
                editor?.focus();
              }}
            />
            <div className="text-end" style={!emptyWarning?{ marginTop: "-20px", paddingBottom: "-11px" } : {marginTop: "5px"}}>
              {tagName !== "" ?
                <Button className="btn-next" style={{ fontSize: '13px' }} onClick={nextTag}>
                  Next Tag<RiArrowRightSLine />
                </Button>
                :
                <Button className="btn-danger" style={{ fontSize: '13px' }} onClick={close}>
                  close
                </Button>}
            </div>
          </div>
        </div>
      }
       <Modal
      show={confirmationModalShow}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => { setConfirmationModalShow(false); close(); }}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <b>Confirmation</b>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className="text-center">
            <h1>
              <RiQuestionLine className="text-danger" />
            </h1>
          </Col>
        </Row>
        <Row>
          <Col className="text-center mt-2">
          <label>
            You have entered values for all the tags inside this field. Do you want to move to the next template field? 
          </label>
          <br/>
          <br/>
          <input type="checkbox" onChange={(e) =>setDoNotShowAgain(e.target.checked)}/><label>&nbsp;Do not show this again</label>
          </Col>
        </Row>
        <hr />
        <Row className="g-2">
          <Col>
            <Button
              variant="primary"
              onClick={() => { setConfirmationModalShow(false); nextFieldClick(); setConfirm(true); close(); }}
              className="w-100"
            >
              <RiCheckFill /> Yes
            </Button>
          </Col>
          <Col>
            <Button variant="danger" onClick={() => { setConfirmationModalShow(false); close(); }} className="w-100">
              <RiCloseFill /> No
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default FormFiller;